import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import {
  validatePhone,
  validateEmail,
} from 'src/app/shared/helpers/customValidators';
import { formateaRut } from 'src/app/shared/helpers/helper';
import { getErrorMessage } from 'src/app/shared/helpers/validationMessages';
import { PersonService } from 'src/app/shared/services/person.service';
import { UbicationService } from 'src/app/shared/services/ubication.service';
import { ProductService } from 'src/app/shared/services/product.service';
import {
  IBanco,
  ICiudad,
  IComuna,
  IDatosAseguradoColectivo,
  IRegion,
  ITipoCuenta,
} from '../../../../shared/Entities/entities';
import { MatDialog } from '@angular/material';
import { statusEnum } from 'src/app/shared/helpers/constants';
import { DialogMessageModalComponent } from 'src/app/shared/components/dialog-message-modal/dialog-message-modal.component';
import { AppInsightsService } from 'src/app/shared/services/app-insights-service';
import { Event } from 'src/app/shared/enums/insights/event';
@Component({
  selector: 'app-card-asegurado',
  templateUrl: './card-asegurado.component.html',
  styleUrls: ['./card-asegurado.component.sass'],
})
export class CardAseguradoComponent implements OnInit, OnDestroy {
  data: IDatosAseguradoColectivo;
  editMode = false;
  loading = false;
  error = false;
  hidebuttonModificar = false;
  getErrorMessage = getErrorMessage;
  @Input() idPoliza: string;
  @Input() lineaNegocio = '';
  @Input() expanded = true;
  form: FormGroup;
  regiones: IRegion[] = [];
  comunas: IComuna[] = [];
  ciudades: ICiudad[] = [];
  tiposCuenta: ITipoCuenta[] = [];
  bancos: IBanco[] = [];
  icon_type: string;
  private subscriptions: Subscription[] = [];
  constructor(
    private personService: PersonService,
    private formBuilder: FormBuilder,
    private ubicationService: UbicationService,
    public dialog: MatDialog,
    private appInsightsService: AppInsightsService,
    private productService: ProductService
  ) {}

  ngOnInit() {
    this.loadTipoCuenta();
    this.loadBancos();
    this.loadRegion();
    this.loadData();
  }

  onEditMode() {
    this.appInsightsService.trackEvent(Event.gidsBtnModifyData);
    this.editMode = true;
  }

  loadRegion() {
    this.ubicationService.getRegiones().subscribe(regiones => {
      this.regiones = regiones.sort((a, b) => {
        const nameA = a.CodigoRegion;
        const nameB = b.CodigoRegion;
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    });
  }

  loadTipoCuenta() {
    this.personService.getTiposCuenta().subscribe(tiposCuenta => {
      this.tiposCuenta = tiposCuenta;
    });
  }

  loadBancos() {
    this.personService.getBancos('COLECTIVOS').subscribe(bancos => {
      this.bancos = bancos;
    });
  }

  getNombreRegionByCodigo(code: string) {
    return code ? this.regiones.find(x => x.CodigoRegion === code).Nombre : '';
  }

  getNombreCuidadByCodigo(code: string) {
    return code ? this.ciudades.find(x => x.CodigoCiudad === code).Nombre : '';
  }

  getNombreComunaByCodigo(code: string) {
    return code ? this.comunas.find(x => x.CodigoComuna === code).Nombre : '';
  }

  getNombreBancoByCodigo(code: string) {
    return code
      ? this.bancos.find(x => x.CodigoBanco === code).NombreBanco
      : '';
  }

  loadData() {
    this.loading = true;
    this.error = false;
    this.hidebuttonModificar = false;
    const dataSubs = this.personService
      .getDatosAseguradosColectivo(this.idPoliza)
      .subscribe(
        data => {
          this.loading = false;
          this.data = data;
          this.regionOnChange({ value: this.data.RegionCodigo });

          this.form = this.formBuilder.group({
            Telefono: [this.data.Telefono, [validatePhone]],
            Correo: [this.data.Correo, [validateEmail]],
            Direccion: [this.data.Direccion, [Validators.maxLength(100)]],
            RegionCodigo: [this.data.RegionCodigo],
            CiudadCodigo: [this.data.CiudadCodigo],
            ComunaCodigo: [this.data.ComunaCodigo.toString()],
            BancoCodigo: [this.data.BancoCodigo.toString()],
            NumeroCuenta: [this.data.NumeroCuenta],
            TipoCuenta: [this.data.TipoCuenta],
          });

          for (const i in this.form.controls) {
            if (i) {
              this.form.controls[i].markAsTouched();
            }
          }
        },
        error => {
          this.loading = false;
          this.error = true;
        }
      );
    this.subscriptions.push(dataSubs);
    this.productService.obtenerCoberturas([this.idPoliza]).subscribe(data => {
      if (data.Coberturas.includes("TEMPORAL VIDA ") || data.Coberturas.includes("SALUD COVID")) {
        if(data.Coberturas.includes("GASTOS SALUD") || data.Coberturas.includes("CATASTRÓFICO ") || data.Coberturas.includes("GASTOS DENTALES")){
          this.hidebuttonModificar = false;
        }else{
          this.hidebuttonModificar = true;
        }  
      }
    });
  }

  offEditMode() {
    this.editMode = false;
    this.loadData();
  }

  resetForm() {
    this.form.reset();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  regionOnChange(event) {
    if (!event) {
      return;
    }
    this.ubicationService.getCiudades(event.value).subscribe(ciudades => {
      if (!ciudades || ciudades.length === 0) {
        return;
      }
      const cityAux = ciudades;
      this.ciudades = cityAux.sort((a, b) => {
        const nameA = a.Nombre.toUpperCase();
        const nameB = b.Nombre.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      // this.comunas = [];
      if (this.editMode) {
        this.form.patchValue(
          {
            ComunaCodigo: null,
            CiudadCodigo: null,
          },
          { onlySelf: true, emitEvent: false }
        );
      } else {
        this.ciudadOnChange({ value: this.data.CiudadCodigo });
      }
    });
  }

  ciudadOnChange(event) {
    if (!event) {
      return;
    }

    this.ubicationService.getComunas(event.value).subscribe(comunas => {
      this.comunas = comunas.sort((a, b) => {
        const nameA = a.Nombre.toUpperCase();
        const nameB = b.Nombre.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
    });
    if (this.editMode) {
      this.form.patchValue(
        {
          ComunaCodigo: null,
        },
        { onlySelf: true, emitEvent: false }
      );
    }
  }

  bancoOnChange(event) {
    if (!event) {
      return;
    }

    this.personService.getBancos('COLECTIVOS').subscribe(bancos => {
      this.bancos = bancos;
      if (this.editMode) {
        this.form.patchValue(
          {
            BancoCodigo: null,
          },
          { onlySelf: true, emitEvent: false }
        );
      }
    });
  }

  save() {
    if (!this.form.valid || !this.form.dirty) {
      return;
    }
    this.appInsightsService.trackEvent(Event.gidsBtnSaveModifyData);
    const data: IDatosAseguradoColectivo = {
      ...this.data,
      ...this.form.value,
    };
    this.personService
      .postDatosAseguradosColectivo(data, this.idPoliza, this.lineaNegocio)
      .subscribe(
        res => {
          this.loadData();
          this.editMode = false;
          this.dialog.open(DialogMessageModalComponent, {
            data: {
              title: 'DATOS GUARDADOS',
              message: 'Datos guardados correctamente.',
              type: statusEnum.success,
            },
            height: '10.3125rem',
            width: '18.125rem',
          });
        },
        error => {
          this.dialog.open(DialogMessageModalComponent, {
            data: {
              title: 'HA OCURRIDO UN PROBLEMA',
              message: 'Inténtelo más tarde.',
              type: statusEnum.error,
            },
            height: '10.3125rem',
            width: '18.125rem',
          });
        }
      );
  }

  formatRUT(rut: string) {
    return formateaRut(rut);
  }

  expandChange() {
    this.appInsightsService.trackEvent(Event.gidsAccShowInsured);
  }
}
